
import {Component, Prop, Vue} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {SancionService} from "@/services/SancionService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";

@Component({
  name: "SancionShow",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  mounted(){
    this.showCuota();
    // if (this.isNew === false){
    //   this.cuenta = this.sancion.cuenta
    //   const data = {
    //     cuenta: this.cuenta
    //   }
    //   this.sancionService.getCiente(data);
    // }
    // else{
    //   this.sancion.fecha = this.fecha
    //   this.sancionStore.cliente = []
    // }
    //console.log("lol" + this.isNew);
    //this.getClientes(333421);
  }
   @Prop() sancion!: any
  @Prop() isNew!: boolean
  @Prop() historial!: any
  private sancionStore = sancionStore();
  private sancionService = SancionService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  valid = false;
  isEdit = false;
  historialVisible = false;
  txtNroTramite = '';
  isLoading = false;
  clientes = [];
  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };
  sumNumber(num1:any, num2:any){
    const total = parseFloat(num1) + parseFloat(num2);
    return Math.round(total * 100) / 100;
  }
  get cuotas(): any[] {
    return this.sancionStore.cuotas;
  }

  get historiales(): any[] {
    return this.sancionStore.historial;
  }
  get loading(): boolean {
    return this.sancionStore.loading;
  }

  buscar() {
    if (!this.$refs.form.validate()) {
      return;
    }

    const data = {
      cuenta: this.cuenta
    }
    this.sancionService.getCiente(data);

  }

  get cliente(): any[] {
    return this.sancionStore.cliente;
  }
  round(value: number) {
    return Math.round(value * 100) / 100;
  }
  update() {
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Actualizar la Sancion del: <br>
                    Cliente: ${this.sancion.cuenta} <br>
                    Total (Bs): ${this.round(this.sancion.total_deuda)}`
    ).then(res => {
      const data = {sancion:this.sancion, cliente:this.cliente}
      if (res.isConfirmed) {
        this.sancionService.updateSancion(data);
        this.$emit('listar');
      }
    })
  }

  planPagos() {
    Alert.confirm(`Generar Plan de Pagos de la Sancion del: <br>
                    Cliente: ${this.sancion.cuenta} <br>
                    Total (Bs): ${this.round(this.sancion.total_deuda)}`
    ).then(res => {
      if (res.isConfirmed) {
        const data = (this.sancion)
        this.sancionService.generarPlanPagos(data);
        //this.$emit('listar');
      }
    })
  }
  anularPlanPagos() {
    const data = (this.sancion)
    this.sancionService.anularPlanPagos(data);

    //this.$emit('listar');

  }
  showCuota(){
    const data = (this.sancion)
    this.sancionService.showCuota(data);
  }

  imprimir(id:number){
    if (this.sancion.meses_plazo > 1 && this.cuotas.length == 0)
      Alert.error("POR FAVOR GENERE PLAN DE PAGOS" + '<br/><br/>' + 'O' + '<br/><br/>' + 'MODIFIQUE LOS MESES DE PLAZO');
    else {
      this.sancionService.imprimirOrden(id);
    }
  }

  imprimirPlan(id:number){
    if (this.sancion.meses_plazo > 1 && this.cuotas.length == 0)
      Alert.error("POR FAVOR GENERE PLAN DE PAGOS" + '<br/><br/>' + 'O' + '<br/><br/>' + 'MODIFIQUE LOS MESES DE PLAZO');
    else {
      this.sancionService.imprimirPlan(id);
    }
  }


  closeSancion() {
    if (this.sancion.meses_plazo > 1 && this.cuotas.length == 0)
      Alert.error("POR FAVOR GENERE PLAN DE PAGOS" + '<br/><br/>' + 'O' + '<br/><br/>' + 'MODIFIQUE LOS MESES DE PLAZO');
    else {
      this.sancionStore.showDialogSancion = false;
      this.sancionStore.sancion = []
      this.sancionStore.cliente = []
      this.sancionStore.cuotas = [];
      this.sancionStore.isNew = false;
      this.sancionStore.loading = false;
      this.cuenta = null;
      this.$emit('listar');
    }
  }


  // get sancion(): any[] {
  //   return this.sancionStore.sancion;
  // }

  // getClientes(val){
  //   http.get("find_by_matricula/" + val).subscribe({
  //     next: (response: any) => {
  //       this.clientes = response.data.cliente.nombre_completo
  //     },
  //     error: (error) => {
  //       console.log(error);
  //     },
  //   });
  // }

}
